import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';

export interface ITaxLetterRequest {
	templateId: string;
	contactId: string;
	donationIds?: string[];
	startDate?: string;
	endDate?: string;
	signatureTemplateId?: string;
}

export interface ITaxLetterResponse {
	html: string;
}

export const useTaxLetterMutation = ({
	onError,
	onSuccess,
}: {
	onError?: (error: Api.IOperationResultNoValue) => void;
	onSuccess?: (data: ITaxLetterResponse) => void;
} = {}) => {
	const userSession = useUserSession();

	return useMutation({
		mutationFn: ({
			request,
			impersonationContext,
		}: {
			request: ITaxLetterRequest;
			impersonationContext?: Api.IImpersonationContext;
		}) => {
			return userSession.webServiceHelper.callAsync<ITaxLetterResponse>(
				Api.ImpersonationBroker.composeApiUrl({
					impersonationContext,
					urlPath: 'donation/taxLetter',
				}),
				'POST',
				request
			);
		},
		onError,
		onSuccess,
	});
};
